import update from 'immutability-helper';
import guid from 'rc-util/lib/guid';
export const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some(item => item.key === key)) {
                parentKey = node.key;
            }
            else if (getParentKey(key, node.children)) {
                parentKey = getParentKey(key, node.children);
            }
        }
    }
    return parentKey;
};
export const editNode = (node, data) => {
    return data === null || data === void 0 ? void 0 : data.map(item => {
        if (item.key === node.key) {
            return update(item, { $merge: { isEditable: true, title: item.title } });
        }
        const children = item.children;
        if (children) {
            return update(item, { children: () => editNode(node, children) });
        }
        return item;
    });
};
export const saveNode = (node, data) => data.map((item) => {
    if (item.key === node.key) {
        return update(item, { $merge: { title: item.title, isEditable: false, disabled: false } });
    }
    const children = item.children;
    if (children) {
        return update(item, { children: () => saveNode(node, children) });
    }
    return item;
});
export const deleteNode = (node, data) => data.map((item) => {
    if (item.key === node.key) {
        return null;
    }
    const children = item.children;
    if (children) {
        return update(item, { children: () => deleteNode(node, children).filter(x => x !== null) });
    }
    return item;
});
export const changeNode = (node, newNodeObj, data) => data.map(item => {
    if (item.key === node.key) {
        return update(item, { $merge: newNodeObj });
    }
    const children = item.children;
    if (children) {
        return update(item, { children: () => changeNode(node, newNodeObj, children) });
    }
    return item;
});
export const addNode = (node, data) => data.map(item => {
    if (item.key === node.key) {
        const dataNode = {
            key: `${node.key}${guid()}`,
            title: '',
            isEditable: true
        };
        return update(item, {
            children: children => update(children || [], {
                $push: [dataNode]
            })
        });
    }
    if (item.children) {
        return update(item, { children: () => addNode(node, item.children) });
    }
    return item;
});
